window.addEventListener("pageshow", function (event) {
  if (event.persisted) {
    document.querySelectorAll('product-form [type="submit"]').forEach(function (b) {
      b.classList.remove("loading");
      b.disabled = false;
    });
  }
});

document.addEventListener("click", async function (e) {

const btn = e.target.closest('product-form [type="submit"]');
if (!btn) return;

e.preventDefault();

if (btn.disabled || btn.classList.contains("loading")) return;

btn.classList.add("loading");
btn.disabled = true;

let items = [];

/* -------------------------
Bundle ID
------------------------- */

let bundleId = "YUMI-" + Date.now();

/* -------------------------
Main Product
------------------------- */

let mainVariant =
document.querySelector('product-form [name="id"]').value;

items.push({
id: mainVariant,
quantity: 1,
properties:{
"Bundle" : bundleId,
"Bundle Type" : "Main Product"
}
});


/* -------------------------
Character Patch
------------------------- */

let character =
document.querySelector('.addon-character input:checked');

if(character){

items.push({
id: character.dataset.variant,
quantity:1,
properties:{
"Bundle" : bundleId,
"Character Patch" : character.dataset.name
}
});

}


/* -------------------------
Carry Your Story
------------------------- */

let sticker =
document.querySelector('.addon-stickers input[type="radio"]:checked');

if(sticker){

items.push({
id: parseInt(sticker.dataset.variant),
quantity:1,
properties:{
"Bundle" : bundleId,
"Carry Your Story" : sticker.dataset.name
}
});

}


/* -------------------------
Bag Tag (FINAL FIX)
------------------------- */

let bagtag = document.querySelector('.bagtag-radio:checked');

if(bagtag){

let name = document.querySelector('[name="properties[Bag Tag Name]"]')?.value || "";
let className = document.querySelector('[name="properties[Bag Tag Class]"]')?.value || "";
let contact = document.querySelector('[name="properties[Bag Tag Contact]"]')?.value || "";
let blood = document.querySelector('[name="properties[Bag Tag Blood Group]"]')?.value || "";

items.push({
id: parseInt(bagtag.dataset.id), // ensure numeric
quantity:1,
properties:{
"Bundle" : bundleId,
"Bag Tag" : bagtag.dataset.name || "",
"Print" : document.querySelector('.bagtag-print-option')?.value || "no",
"Name" : name,
"Class" : className,
"Emergency Contact" : contact,
"Blood Group" : blood
}
});

}


/* -------------------------
Name Initials
------------------------- */

let initials =
document.querySelector(".addon-initials");

if(initials && initials.value){

items.push({
id: document.getElementById("initialsVariant").value,
quantity:1,
properties:{
"Bundle" : bundleId,
"Name Initials" : initials.value
}
});

}


/* -------------------------
Name Patch
------------------------- */

let patch =
document.querySelector(".addon-patch");

if(patch && patch.value){

items.push({
id: document.getElementById("patchVariant").value,
quantity:1,
properties:{
"Bundle" : bundleId,
"Name Patch" : patch.value
}
});

}


/* -------------------------
Acrylic Keychain
------------------------- */

let acrylic =
document.querySelector(".addon-acrylic");

if(acrylic && acrylic.value){

items.push({
id: document.getElementById("acrylicVariant").value,
quantity:1,
properties:{
"Bundle" : bundleId,
"Acrylic Keychain" : acrylic.value
}
});

}


/* -------------------------
Add All to Cart
------------------------- */

try {

const response = await fetch('/cart/add.js',{
method:'POST',
headers:{
'Content-Type':'application/json'
},
body:JSON.stringify({
items:items
})
});

if(response.ok){
window.location.href="/cart";
} else {
const errorData = await response.json();
console.error("Shopify Cart API Error:", errorData);
alert("Failed to add items to cart: " + (errorData.description || "Unknown error"));
btn.classList.remove("loading");
btn.disabled = false;
}

} catch(err){
console.error("Network Error:", err);
btn.classList.remove("loading");
btn.disabled = false;
}

});